var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3605.5928,
    y1: 4068.9263,
    x2: 1151.7584,
    y2: 1021.4179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_1_)"
    },
    d: "M2930.528,2867.099c-56.364,59.337-109.694,97.603-151.83,127.836 c-495.295,355.38-1081.361,251.788-1205.917,226.49c-183.929-37.357-539.461-109.567-796.504-411.845 c-388.884-457.32-328.329-1177.815-26.684-1653.424c55.176-86.997,346.629-569.85,939.007-647.285 c358.501-46.862,776.398,47.654,1079.027,301.197C3402.873,1342.279,3357.65,2417.438,2930.528,2867.099z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014616221601839552880000008239500623326850436_",
    gradientUnits: "userSpaceOnUse",
    x1: 7355.5776,
    y1: 628.5682,
    x2: 8641.5664,
    y2: 628.5682,
    gradientTransform: "matrix(0.9613 0.2755 -0.2755 0.9613 -6496.8516 -1384.1506)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014616221601839552880000008239500623326850436_)"
    },
    d: "M624.804,474.777 c-4.536-13.999,11.787-25.503,23.583-16.704c119.784,89.334,414.427,364.134,410.081,903.391 c-5.452,676.579,161.24,904.282,351.16,1033.146c0,0-245.575-42.837-423.172-272.929 C550.416,1556.749,705.448,723.683,624.804,474.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M730.862,673.85c21.985,72.752,42.523,145.899,60.358,219.692 c18.219,73.686,34.196,147.892,47.837,222.488c13.354,74.643,25.305,149.524,34.058,224.802 c9.091,75.235,14.94,150.776,20.547,226.641c6.028,75.79,11.669,152.175,25.147,228.215 c13.381,75.893,36.036,151.408,71.817,220.545c8.938,17.228,18.226,34.361,28.43,50.775 c9.904,16.611,20.546,32.787,31.474,48.766c22.019,31.857,46.191,62.307,72.511,90.825 c52.794,56.911,114.215,105.737,180.278,145.459c6.953,4.181,15.979,1.933,20.16-5.021c4.105-6.827,2.012-15.654-4.649-19.929 l-0.047-0.03c-15.795-10.116-31.454-20.401-46.601-31.348c-7.663-5.354-15.072-11.036-22.584-16.576 c-7.294-5.818-14.816-11.355-21.922-17.393c-28.824-23.662-55.953-49.319-81.05-76.855 c-50.41-54.766-92.895-117.349-127.193-183.336c-16.782-33.198-31.089-67.573-42.7-102.932 c-11.586-35.37-20.472-71.686-27.292-108.536c-13.653-73.741-19.861-149.299-26.433-225.042 c-6.672-75.75-13.897-151.826-24.241-227.486c-5.069-37.839-10.818-75.583-17.24-113.204 c-3.102-18.828-6.569-37.593-10.001-56.361c-3.612-18.735-7.328-37.448-11.194-56.127 c-15.607-74.69-33.485-148.867-53.682-222.376c-20.549-73.411-43.039-146.253-68.297-218.105 c-0.723-2.054-2.972-3.133-5.025-2.411C731.334,669.693,730.261,671.846,730.862,673.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039826045373416294710000002093699999574825631_",
    gradientUnits: "userSpaceOnUse",
    x1: -2411.1274,
    y1: 7561.8682,
    x2: -833.6423,
    y2: 7561.8682,
    gradientTransform: "matrix(0.1013 -0.995 0.995 0.1013 -6539.1011 -329.2292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CE1567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A1DBC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039826045373416294710000002093699999574825631_)"
    },
    d: "M1190.32,2846.207 c-4.703,26.703-35.149,39.925-58.063,25.43c-126.436-79.976-463.467-338.425-524.483-851.274 c-51.525-433.078-120.619-663.014-159.219-765.223c-8.162-21.613,16.011-41.083,35.414-28.542 C698.034,1364.964,1360.737,1878.615,1190.32,2846.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1154.193,2852.744c-0.488,0.462-1.025,0.883-1.615,1.257 c-4.934,3.136-11.476,1.678-14.612-3.255c-3.555-5.594-356.607-566.216-455.451-1165.145c-0.949-5.764,2.953-11.212,8.722-12.17 c5.77-0.95,11.216,2.953,12.171,8.723c98.123,594.57,448.895,1151.68,452.426,1157.236 C1158.598,2843.735,1157.796,2849.328,1154.193,2852.744z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160189351422652798490000011564185120498770614_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.7044,
    y1: 1873.8488,
    x2: 2693.8237,
    y2: 1873.8488,
    gradientTransform: "matrix(0.9998 -0.0219 0.0219 0.9998 28.2232 -27.654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160189351422652798490000011564185120498770614_)"
    },
    d: "M1127.063,510.963 c-68.36,5.945-120.772,63.196-120.967,131.815c-1.19,419.629-3.154,1867.04,24.197,2379.343 c2.898,54.274,47.393,96.91,101.741,97.495c268.807,2.894,1042.022,8.211,1480.979-19.867 c91.428-5.848,162.573-81.571,162.463-173.186c-0.533-440.415-7.57-1679.015-67.899-2245.164 c-7.228-67.833-61.756-120.781-129.767-126.08C2284.635,532.476,1506.104,477.998,1127.063,510.963z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126281119439411773100000012194073571333988015_",
    gradientUnits: "userSpaceOnUse",
    x1: 1191.9775,
    y1: 834.6511,
    x2: 4901.5864,
    y2: 6038.5195,
    gradientTransform: "matrix(1 -0.0042 0.0042 1 5.3179 -4.8586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126281119439411773100000012194073571333988015_)"
    },
    d: "M1113.999,752.749 c-5.279,358.955-20.309,1553.05,5.929,1993.769c3.835,64.417,53.873,115.274,115.658,117.427 c254.388,8.865,906.724,26.021,1278.436-14.88c66.933-7.365,118.089-65.381,119.872-135.631 c9.298-366.313,34.413-1478.474,8.913-1914.265c-4.068-69.521-57.182-124.993-123.761-129.48 c-275.442-18.56-982.743-61.362-1298.834-35.039C1160.874,639.592,1114.913,690.605,1113.999,752.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F5AA9"
    },
    d: "M1728.63,573.375c0.218,9.917,8.126,17.926,18.041,18.228 c48.948,1.487,186.838,5.708,248.47,7.929c12.152,0.438,21.438-10.681,18.874-22.567c-0.211-0.375-1.79-15.615-17.354-16.697 c-41.691-2.899-167.47-10.715-250.588-5.919C1729.005,555.333,1728.077,574.744,1728.63,573.375z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 1529.104,
    cy: 1222.65,
    r: 333.64
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000052818178886198420250000004633804244688114564_",
    cx: 1529.104,
    cy: 1222.65,
    r: 297.133
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171708621820566350330000013707341587232216748_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052818178886198420250000004633804244688114564_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095312227629532276200000005455039737880490651_",
    gradientUnits: "userSpaceOnUse",
    x1: 1240.4829,
    y1: 2148.5271,
    x2: 1925.9784,
    y2: -220.1579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000171708621820566350330000013707341587232216748_)",
      fill: "url(#SVGID_00000095312227629532276200000005455039737880490651_)"
    },
    cx: 1530.394,
    cy: 1146.758,
    r: 130.215
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118390689742727461700000006265065723169700230_",
    gradientUnits: "userSpaceOnUse",
    x1: 1342.7932,
    y1: 2178.1355,
    x2: 2028.2892,
    y2: -190.5511
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000171708621820566350330000013707341587232216748_)",
      fill: "url(#SVGID_00000118390689742727461700000006265065723169700230_)"
    },
    d: " M1332.606,1537.782h414.848c25.434,0,40.673-32.866,26.977-57.946c-35.237-64.525-108.962-159.32-236.644-155.042 c-123.059,4.122-195.998,89.748-232.665,151.157C1289.556,1502.021,1305.431,1537.782,1332.606,1537.782z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140005738301892186250000016863313464639955347_",
    gradientUnits: "userSpaceOnUse",
    x1: 2085.2551,
    y1: 1545.1315,
    x2: 1695.9434,
    y2: 3154.783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140005738301892186250000016863313464639955347_)"
    },
    d: "M2033.735,2699.748h-414.997 c-13.562,0-24.658-11.096-24.658-24.657v-118.037c0-13.562,11.096-24.657,24.658-24.657h414.997 c13.562,0,24.657,11.096,24.657,24.657v118.037C2058.392,2688.652,2047.297,2699.748,2033.735,2699.748z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2344.375,1926.416h-936.224c-7.439,0-13.525-6.086-13.525-13.524v-65.095 c0-7.438,6.086-13.525,13.525-13.525h936.224c7.438,0,13.525,6.086,13.525,13.525v65.095 C2357.899,1920.33,2351.813,1926.416,2344.375,1926.416z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 1271.067,
    cy: 1880.064,
    r: 55.862
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2344.375,2099.324h-936.224c-7.439,0-13.525-6.086-13.525-13.524v-65.095 c0-7.438,6.086-13.525,13.525-13.525h936.224c7.438,0,13.525,6.086,13.525,13.525v65.095 C2357.899,2093.238,2351.813,2099.324,2344.375,2099.324z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -958.9979 2978.7756)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 1271.067,
    cy: 2052.971,
    rx: 55.862,
    ry: 55.862
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2344.375,2272.231h-936.224c-7.439,0-13.525-6.086-13.525-13.524v-65.095 c0-7.438,6.086-13.524,13.525-13.524h936.224c7.438,0,13.525,6.086,13.525,13.524v65.095 C2357.899,2266.145,2351.813,2272.231,2344.375,2272.231z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 1271.067,
    cy: 2225.879,
    r: 55.862
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2344.375,2445.139h-936.224c-7.439,0-13.525-6.086-13.525-13.524v-65.095 c0-7.438,6.086-13.524,13.525-13.524h936.224c7.438,0,13.525,6.086,13.525,13.524v65.095 C2357.899,2439.053,2351.813,2445.139,2344.375,2445.139z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 1271.067,
    cy: 2398.786,
    r: 55.862
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1963.743,1746.328h-734.347c-6.6,0-12-5.4-12-12v-68.144c0-6.6,5.4-12,12-12h734.347 c6.6,0,12,5.4,12,12v68.144C1975.743,1740.928,1970.343,1746.328,1963.743,1746.328z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098927333661825715460000011789800361748850833_",
    gradientUnits: "userSpaceOnUse",
    x1: 3631.418,
    y1: -393.2141,
    x2: 1961.5092,
    y2: 1449.6729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098927333661825715460000011789800361748850833_)"
    },
    d: "M2811.604,817.29 c-1.972-30.484-20.382-57.488-47.975-70.594l-357.508-169.793c-22.895-10.874-49.467-10.874-72.362,0l-357.508,169.793 c-27.594,13.105-46.003,40.11-47.975,70.594c-33.534,518.356,298.829,707.223,407.781,754.933 c21.607,9.462,46.157,9.462,67.765,0C2512.775,1524.513,2845.138,1335.645,2811.604,817.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2261.802,651.85c-3.175,0-6.219-1.789-7.67-4.848c-2.01-4.232-0.209-9.292,4.023-11.301 l84.474-40.119c4.239-2.018,9.296-0.212,11.304,4.023c2.01,4.232,0.209,9.292-4.023,11.301l-84.474,40.119 C2264.26,651.585,2263.021,651.85,2261.802,651.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1955.614,931.628c-4.553,0-8.32-3.612-8.474-8.199c-1.135-33.833-0.54-69.094,1.771-104.805 c1.485-22.946,15.36-43.35,36.212-53.249l240.497-114.224c4.234-2.018,9.292-0.212,11.304,4.023 c2.01,4.232,0.209,9.292-4.023,11.301l-240.498,114.224c-15.296,7.264-25.471,22.217-26.56,39.019 c-2.273,35.161-2.862,69.862-1.745,103.141c0.157,4.683-3.511,8.607-8.194,8.766 C1955.806,931.628,1955.71,931.628,1955.614,931.628z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123428606208090734840000010307324309595568063_",
    gradientUnits: "userSpaceOnUse",
    x1: 2751.2266,
    y1: 503.492,
    x2: 1081.3164,
    y2: 2632.4573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123428606208090734840000010307324309595568063_)"
    },
    d: "M2725.152,837.521 c-0.395-7.728-4.995-14.626-11.985-17.946l-334.208-158.729c-5.707-2.71-12.329-2.71-18.035,0l-334.208,158.729 c-6.99,3.32-11.59,10.218-11.985,17.946c-9.883,193.362,34.78,354.698,132.843,479.744 c74.763,95.336,162.223,146.426,213.473,170.261c5.646,2.626,12.144,2.626,17.79,0 c51.249-23.835,138.709-74.926,213.473-170.261C2690.371,1192.22,2735.035,1030.882,2725.152,837.521z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121989686703939776950000010665913417934704561_",
    gradientUnits: "userSpaceOnUse",
    x1: 1732.2551,
    y1: 1651.3348,
    x2: 2849.9634,
    y2: 686.647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121989686703939776950000010665913417934704561_)"
    },
    d: "M2157.708,1049.459L2157.708,1049.459 c27.632-17.119,63.94-8.178,80.455,19.823l77.686,131.689c7.78,13.184,27.257,11.868,33.19-2.24l174.78-415.65 c8.72-20.736,39.431-14.535,39.635,7.953c1.15,125.826-26.456,365.709-222.596,570.679c0,0-111.789-40.378-205.701-234.073 C2121.594,1099.661,2131.277,1065.84,2157.708,1049.459z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160877095954741298720000012136179052236396720_",
    gradientUnits: "userSpaceOnUse",
    x1: -2103.5349,
    y1: 3078.1323,
    x2: -2721.5349,
    y2: 3750.3438,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160877095954741298720000012136179052236396720_)"
    },
    d: "M2870.053,3128.208 c0,0,6.4,36.232,9.538,72.098c1.227,14.018-9.58,26.188-23.639,26.774c-47.763,1.989-149.93,5.858-186.592,4.222 c-5.511-0.246-9.115-5.888-7.075-11.014l0,0c1.709-4.295,5.006-7.768,9.206-9.698l168.761-77.563L2870.053,3128.208z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156576773798526404210000004273995919498264474_",
    gradientUnits: "userSpaceOnUse",
    x1: -2304.1284,
    y1: 3128.0586,
    x2: -2249.2349,
    y2: 3128.0586,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156576773798526404210000004273995919498264474_)"
    },
    d: "M2875.296,3106.919l-5.142,43.339 c0,0-29.563,13.762-49.752-1.735l12.243-48.297L2875.296,3106.919z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139996909734577800020000004451673461441669537_",
    gradientUnits: "userSpaceOnUse",
    x1: -2434.2944,
    y1: 2708.3225,
    x2: -2252.7883,
    y2: 2708.3225,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139996909734577800020000004451673461441669537_)"
    },
    d: "M2871.431,2292.137 c2.221,11.318,11.922,564.778-47.239,812.802c-0.966,4.047,1.086,8.219,4.938,9.792c9.074,3.708,26.863,9.076,48.181,9.792 c6.602,0.222,12.521-4.069,14.384-10.407c16.911-57.545,97.945-345.865,108.516-621.287c11.812-307.758,0-10.479,0-10.479 l-6.928-190.237L2871.431,2292.137z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043455812292764685790000015797983035037282460_",
    gradientUnits: "userSpaceOnUse",
    x1: -2242.1729,
    y1: 2950.6746,
    x2: -2860.1738,
    y2: 3622.8867,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043455812292764685790000015797983035037282460_)"
    },
    d: "M3064.185,3147.111 c0,0,10.188,18.291,20.051,66.896c1.781,8.778-4.352,17.179-13.265,18.055c-15.771,1.551-40.051,3.545-59.5,3.411 c-8.966-0.062-15.963-7.868-14.882-16.769c2.154-17.741,8.865-46.848,29.598-69.535L3064.185,3147.111z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026158953054287422070000014720613399307335355_",
    gradientUnits: "userSpaceOnUse",
    x1: -2501.9651,
    y1: 3125.2434,
    x2: -2454.5696,
    y2: 3125.2434,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026158953054287422070000014720613399307335355_)"
    },
    d: "M3073.133,3091.367l-12.015,65.54 c0,0-11.88,8.836-35.381,2.43l5.735-70.517L3073.133,3091.367z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023270682139728655940000017271089938678765202_",
    gradientUnits: "userSpaceOnUse",
    x1: -2553.0505,
    y1: 2702.3835,
    x2: -2295.3701,
    y2: 2702.3835,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023270682139728655940000017271089938678765202_)"
    },
    d: "M3105.592,2309.121 c48.385,292.01-10.496,721.728-30.354,805.834c-1.216,5.149-5.371,9.094-10.591,9.959c-8.864,1.469-23.458,2.668-37.845-1.51 c-4.957-1.44-8.44-5.911-8.642-11.069c-2.664-67.998,2.131-485.434-42.953-650.407c-2.285-8.36-7.39-15.652-14.455-20.674 l-87.505-62.209l-6.709-100.555L3105.592,2309.121z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034805994123602984510000002555777341120821146_",
    gradientUnits: "userSpaceOnUse",
    x1: 2948.8174,
    y1: 1830.058,
    x2: 2653.55,
    y2: 2624.2249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CE1567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A1DBC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034805994123602984510000002555777341120821146_)"
    },
    d: "M2797.277,1755.817 c145.003-2.396,304.996,38.074,304.996,38.074c43.222,252.2,7.558,543.095,7.558,543.095 c-112.258,29.439-238.89-17.999-238.89-17.999c-18.658-105.413-105.711-402.082-105.711-402.082 c-70.848-8.793-129.211-29.233-177.273-56.258c36.661-42.496,53.944-96.57,61.451-128.534 C2700.676,1748.046,2752.553,1756.556,2797.277,1755.817z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097484007963820938170000013340961836054129331_",
    gradientUnits: "userSpaceOnUse",
    x1: -2078.241,
    y1: 1695.9471,
    x2: -1797.7981,
    y2: 1695.9471,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097484007963820938170000013340961836054129331_)"
    },
    d: "M2368.966,1542.237 c14.244-17.205,32.272-9.066,32.272-9.066c21.338,90.136,133.224,163.219,248.171,198.943 c-7.507,31.964-24.79,86.038-61.451,128.534C2397.193,1753.388,2368.966,1542.237,2368.966,1542.237z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068674466881925556190000012748773760626466744_",
    gradientUnits: "userSpaceOnUse",
    x1: 12308.0498,
    y1: 1648.9384,
    x2: 12496.2334,
    y2: 2077.0989,
    gradientTransform: "matrix(1 0 0 1 -9876.6104 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068674466881925556190000012748773760626466744_)"
    },
    d: "M2372.423,1546.612 c-1.49,4.738,15.769,11.953,25.932-7.426c0.355-9.288,6.003-49.077,0.454-56.643c-29.558-40.298-86.865-90.813-86.865-90.813 c-9.685,9.557-1.706,18.945-1.706,18.945l27.8,28.96c-5.814,10.508-12.907,19.377-16.231,32.088 c-2.518,9.625-0.978,19.911,3.884,28.671c4.88,8.792,11.537,20.22,17.831,29.163 C2355.435,1546.484,2372.423,1546.612,2372.423,1546.612z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044172977238354886460000014920887616430929539_",
    gradientUnits: "userSpaceOnUse",
    x1: -1799.1442,
    y1: 1506.3455,
    x2: -1720.6229,
    y2: 1385.6188,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044172977238354886460000014920887616430929539_)"
    },
    d: "M2350.198,1458.425l25.333,21.476 l7.954,21.382l-22.587,25.057c0,0-7.594-42.426-13.239-51.609C2342.014,1465.551,2344.941,1461.111,2350.198,1458.425z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008844110521042351090000002784885758181795768_",
    gradientUnits: "userSpaceOnUse",
    x1: 3173.6892,
    y1: 1913.6641,
    x2: 2878.4221,
    y2: 2707.8291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CE1567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A1DBC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008844110521042351090000002784885758181795768_)"
    },
    d: "M3046.656,1934.296l55.617-140.405 c0,0,135.44,92.026,157.714,208.705c-25.591,1.885-72.159,8.541-117.74,31.557 C3132.23,1979.058,3046.656,1934.296,3046.656,1934.296z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073690814530539936660000000455697265582212769_",
    gradientUnits: "userSpaceOnUse",
    x1: -2691.9072,
    y1: 2093.1868,
    x2: -2337.0046,
    y2: 2093.1868,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073690814530539936660000000455697265582212769_)"
    },
    d: "M2928.296,2066.412 c0,0,152.065,85.94,203.375,12.557c10.653-15.237,13.2-30.381,10.576-44.817c45.581-23.016,92.149-29.672,117.74-31.557 c6.716,35.174,3.166,72.585-17.504,110.396c-89.876,164.409-334.311-9.086-334.311-9.086L2928.296,2066.412z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110468137347555241100000006175583197468212101_",
    gradientUnits: "userSpaceOnUse",
    x1: -2229.6338,
    y1: 1840.8621,
    x2: -2034.4858,
    y2: 2653.9807,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110468137347555241100000006175583197468212101_)"
    },
    d: "M2946.567,2175.135l-82.991-289.825 c-0.942-3.29-3.749-5.69-7.148-6.086c-15.037-1.754-58.607-6.679-108.914-10.934c-60.595-5.125-130.965-9.279-173.016-5.746 c-5.978,0.502-9.591,6.825-6.932,12.203c23.912,48.378,122.273,245.168,171.53,309.634c1.632,2.136,4.155,3.384,6.843,3.359 l192.555-1.791C2944.097,2185.897,2948.11,2180.522,2946.567,2175.135z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066482527992960305920000010528534267990609339_",
    gradientUnits: "userSpaceOnUse",
    x1: -2107.4526,
    y1: 1712.6917,
    x2: -2149.0142,
    y2: 1895.2008,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066482527992960305920000010528534267990609339_)"
    },
    d: "M2738.906,1843.163l-60.17-10.026 c-3.205-0.534-5.829,2.528-4.811,5.613l5.956,18.049c0.519,1.571,1.889,2.708,3.529,2.927l57.902,7.735 c2.996,0.4,5.465-2.322,4.777-5.265l-3.687-15.758C2742.004,1844.741,2740.625,1843.449,2738.906,1843.163z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052806652503932119300000006858777820235251371_",
    gradientUnits: "userSpaceOnUse",
    x1: -2129.2039,
    y1: 1789.2488,
    x2: -2149.0811,
    y2: 1908.5121,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052806652503932119300000006858777820235251371_)"
    },
    d: "M2783.96,1894.102l-4.957-25.819 c-0.497-2.59-2.635-4.546-5.259-4.813l-121.53-12.332c-4.091-0.415-7.366,3.334-6.406,7.331l7.727,32.174 c0.618,2.574,2.859,4.434,5.503,4.567l118.76,5.978C2781.664,1901.382,2784.69,1897.903,2783.96,1894.102z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114032137876786964810000004279125440245197703_",
    gradientUnits: "userSpaceOnUse",
    x1: -2363.3547,
    y1: 2055.9753,
    x2: -2252.7883,
    y2: 2055.9753,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114032137876786964810000004279125440245197703_)"
    },
    d: "M2926.517,2105.113 c0,0,11.561-47.538,6.897-64.403c-4.663-16.865-13.698-38.55-43.815-33.731c-30.117,4.819-65.643,17.505-65.643,17.505 s1.795,21.968,24.684,14.881l-14.194,10.983c0,0,2.029,17.59,21.363,8.192l-13.201,14.566c0,0,8.303,14.446,22.527,5.18 C2879.359,2069.02,2886.177,2110.837,2926.517,2105.113z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065074291648156272350000013596486091555904440_",
    gradientUnits: "userSpaceOnUse",
    x1: -2419.3914,
    y1: 1713.7739,
    x2: -2279.0747,
    y2: 1713.7739,
    gradientTransform: "matrix(-1 0 0 1 571.1675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065074291648156272350000013596486091555904440_)"
    },
    d: "M2944.153,1638.098l46.137,133.426 c0.764,2.21-0.144,4.658-2.191,5.789c-12.577,6.954-57.888,27.053-112.492-7.567c-5.688-3.606-9.56-9.489-10.424-16.168 l-14.941-115.481H2944.153z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095305669707782302070000005521493037252386190_",
    gradientUnits: "userSpaceOnUse",
    x1: -7116.5674,
    y1: -3098.1804,
    x2: -7169.002,
    y2: -3271.123,
    gradientTransform: "matrix(-0.746 -0.6659 -0.6659 0.746 -4555.168 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095305669707782302070000005521493037252386190_)"
    },
    d: "M2843.764,1514.541 c0,0-50.664,95.369-44.17,133.893c6.494,38.524,69.284,35.758,124.114,4.47l38.315-102.978L2843.764,1514.541z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062175352384776168220000012558497724449548987_",
    gradientUnits: "userSpaceOnUse",
    x1: -7163.8735,
    y1: -3399.5071,
    x2: -7120.0122,
    y2: -3149.3347,
    gradientTransform: "matrix(-0.746 -0.6659 -0.6659 0.746 -4555.168 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062175352384776168220000012558497724449548987_)"
    },
    d: "M2921.285,1602.333 c-2.229-0.987-3.051-3.714-1.716-5.753c4.059-6.201,11.668-18.852,14.095-29.927c0,0,9.108-5.833-23.181-13.562 c-32.289-7.729-80.44-19.725-90.562-47.209c-9.867-26.796,16.06-94.184,57.423-40.49c1.574,2.043,4.657,2.088,6.228,0.043 c6.781-8.826,24.608-27.144,49.359-16.039c23.162,10.393,25.771,27.365,25.453,35.92c-0.094,2.517,2.156,4.473,4.63,4.001 c11.711-2.233,39.813-4.151,52.929,24.677c10.804,23.745,3.782,37.187-2.614,43.76c-2.072,2.13-1.164,5.637,1.677,6.507 c7.697,2.356,17.635,8.882,16.64,26.913c-1.375,24.928-29.246,22.732-37.181,21.595c-1.3-0.186-2.61,0.26-3.49,1.234 c-6.804,7.529-37.459,39.499-70.636,43.353c-2.873,0.334-5.099-2.504-4.158-5.238l14.358-41.738 c0.667-1.938-0.26-4.065-2.135-4.895L2921.285,1602.333z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012440188091301017750000002940150652614099647_",
    gradientUnits: "userSpaceOnUse",
    x1: -7170.168,
    y1: -3098.9854,
    x2: -7217.3447,
    y2: -3254.5852,
    gradientTransform: "matrix(-0.746 -0.6659 -0.6659 0.746 -4555.168 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012440188091301017750000002940150652614099647_)"
    },
    d: "M2915.513,1608.257 c0,0,36.073-24.749,38.709-3.907c2.635,20.842-32.484,30.19-49.879,22.419L2915.513,1608.257z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService7);
export default __webpack_public_path__ + "static/media/service7.ed03c93aaf7309e0b418aadef7abc05b.svg";
export { ForwardRef as ReactComponent };